import React, {useContext} from "react";
import PageTitle from "../../../layout/PageTitle";
import {useMutation, useQuery} from "@apollo/client";
import {tableImageTag} from "../../../helpers/Api";
import {CustomButton} from "../../../helpers/ButtonHelper";
import ListTable from "../../shared/ListTable";
import {getNotifications, markNotificationAsReadMutation} from "./NotificationsQueries";
import {AuthContext} from "../../../context/authContext";
import {NavLink} from "react-router-dom";

const ClientsList = () => {
  const { data } = useQuery(getNotifications, { fetchPolicy: 'network-only' })
  const [readActionCall] = useMutation(markNotificationAsReadMutation)
  const { reloadUser } = useContext(AuthContext)

  const markAsRead = (e, id) => {
    e.preventDefault()
    readActionCall({
      variables: { id: id },
      onCompleted: ({ markNotificationRead }) => {
        markNotificationRead.notifications.forEach(item => {
          document.getElementById(`notification_${item.id}`)?.remove()
        })
        reloadUser()
      },
      onError: (res) => {
        console.log(res)
      }
    })
  }

  const header = <tr>
    <th>Data</th>
    <th></th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.time}</td>
      <td>
        <NavLink to={`/clients/${item.client.id}`}>
          {tableImageTag(item, { type: 'avatar', src: item.client.avatar })}
          {item.client.fullName}
        </NavLink>
        &nbsp;
        {item.readableMessage}
      </td>
      <td className='actions'>
        {!item.read &&
          <CustomButton text='Marcheaza ca si citit' icon='eye' className='btn-outline-primary'
                        onClick={e => markAsRead(e, item.id)} id={`notification_${item.id}`} />
        }
      </td>
    </tr>
  }

  return (
    <div className="container">
      <PageTitle title='Notificari' buttons={
        <CustomButton text='Marcheaza tot ca si citit' icon='eye' className='btn-outline-primary' size='md'
                      onClick={e => markAsRead(e, 'all')} />
      } />
      <div className="row justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.notifications} header={header} listItem={listItem}
                     searchFields={['client.fullName', 'title', 'time']}
          />
        </div>
      </div>
    </div>
  )
};

export default ClientsList;
